// What the sign-in page says when POST /api/auth/login fails.
//
// A wrong username and a wrong password (401, or 400 for a malformed body)
// get the SAME line: no "username exists" oracle. A rate limit or a server
// fault is not the user's password, so it is not reported as one, and the
// rate limit's wait is the server's Retry-After: seconds when a locked
// login is letting one attempt through at a time, up to 15 minutes when
// that address has been guessing (services/login_throttle.py).

import { ApiError } from "./api";

export function tooManyAttempts(retryAfter: number | null): string {
  if (retryAfter === null || retryAfter <= 60) return "Too many attempts. Wait a moment and try again.";
  return `Too many attempts. Wait ${Math.ceil(retryAfter / 60)} minutes and try again.`;
}

export function signInError(e: unknown): string {
  if (!(e instanceof ApiError)) return "Can't reach Corvus right now. Check your connection and try again.";
  if (e.status === 400 || e.status === 401) return "That username and password don't match. Try again.";
  if (e.status === 429) return tooManyAttempts(e.retryAfter);
  return "Corvus couldn't sign you in just now. Try again in a moment.";
}
